// Work-experience relevance comes back as a cosine similarity (0→1) between the
// experience's embedding and the job's. Similarities cluster high — unrelated
// blue-collar roles still share vocabulary — so the buckets sit between 0.45 and
// 0.80 rather than spreading evenly across the full range. Calibrate these against
// real score spread before trusting the middle buckets.
const relevanceRatingThresholds: { minScore: number; rating: number }[] = [
  { minScore: 0.8, rating: 5 },
  { minScore: 0.72, rating: 4 },
  { minScore: 0.64, rating: 3 },
  { minScore: 0.56, rating: 2 },
  { minScore: 0.45, rating: 1 },
];

// Buckets a cosine similarity into a 0-5 relevance rating. 0 means the embedding
// found nothing in common; null/undefined scores return null so callers can tell
// "unscored" apart from "irrelevant".
export const relevanceCosineScoreToRating = (
  score: number | null | undefined,
): number | null => {
  if (score === null || score === undefined) return null;

  const match = relevanceRatingThresholds.find(
    (threshold) => score >= threshold.minScore,
  );

  return match?.rating ?? 0;
};
